import qs from 'qs'

import { getRawRequest, getRequest } from '../../../../utils'
import { SalesWithoutVatParams } from './hooks/useFetchSalesWithoutVat'

interface FetchSalesWithoutVATFileArgs {
  fromDate: string
  organizationId: string
  toDate: string
}

export const fetchSalesWithoutVATFile = ({ fromDate, organizationId, toDate }: FetchSalesWithoutVATFileArgs) => {
  const queryParams = qs.stringify({
    fromDate,
    toDate,
    asCsv: true,
  })

  return getRawRequest(`/v2/organizations/${organizationId}/salesWithoutVat?${queryParams}`)
}

export interface SalesWithoutVat {
  id: string
  name: string
  countryId: string
  registrationNo: string
  minDate: string
  maxDate: string
  V?: number
  Y?: number
}

export interface SalesApiResponse {
  result: SalesWithoutVat[]
}

export const getSalesWithoutVatList = async (
  organizationId: string,
  params: SalesWithoutVatParams,
): Promise<SalesApiResponse> => {
  return getRequest(`/v2/organizations/${organizationId}/salesWithoutVat?${qs.stringify(params)}`)
}
